export const formatCurrency = (amount?: { value: number; currency: string }) => {
  if (!amount) return;

  return `${new Intl.NumberFormat('en-US').format(amount.value)} ${amount.currency}`;
};
